<script>
import lang from "@/directives/lang";
import { i18n } from "@/i18n";

const wordClassMapping = {
  "adj.": i18n.global.t("article.polSchoolDada.wordClass.adjective"),
  "adj. flertal": i18n.global.t("article.polSchoolDada.wordClass.adjectivePlural"),
  "adv.": i18n.global.t("article.polSchoolDada.wordClass.adverb"),
  artikel: i18n.global.t("article.polSchoolDada.wordClass.article"),
  egennavn: i18n.global.t("article.polSchoolDada.wordClass.properName"),
  "formelt subjekt": i18n.global.t("article.polSchoolDada.wordClass.formalSubject"),
  "i sammensætninger": i18n.global.t("article.polSchoolDada.wordClass.inCombinations"),
  "konj.": i18n.global.t("article.polSchoolDada.wordClass.subjunctive"),
  "navneformens mærke": i18n.global.t("article.polSchoolDada.wordClass.infinitiveMarker"),
  lydord: i18n.global.t("article.polSchoolDada.wordClass.onomatopoeic"),
  "pron.": i18n.global.t("article.polSchoolDada.wordClass.pronoun"),
  "præp.": i18n.global.t("article.polSchoolDada.wordClass.preposition"),
  "subst.": i18n.global.t("article.polSchoolDada.wordClass.noun"),
  "subst. flertal": i18n.global.t("article.polSchoolDada.wordClass.nounPlural"),
  talord: i18n.global.t("article.polSchoolDada.wordClass.number"),
  udråbsord: i18n.global.t("article.polSchoolDada.wordClass.interjection"),
  "verb.": i18n.global.t("article.polSchoolDada.wordClass.verb")
};

export default {
  name: "ArticleContentHeader",
  directives: {
    lang
  },
  props: {
    word: {
      type: Object,
      required: true
    }
  },
  computed: {
    wordClassInfo() {
      const [rawWordClass, rawPronoun = ""] = this.word.wordClass.split(/<i>/g);

      const wordClass = rawWordClass
        .split(",")
        .map((rawWordClass) => {
          const trimmedWordClass = rawWordClass.replace(/^ +/g, "").replace(/ +$/g, "");
          return trimmedWordClass in wordClassMapping
            ? wordClassMapping[trimmedWordClass]
            : trimmedWordClass;
        })
        .join(", ");

      const pronoun = rawPronoun.replace(/<\/i>/g, "");

      return {
        wordClass: wordClass,
        pronoun: pronoun
      };
    }
  }
};
</script>

<template>
  <div class="article-content__header article-header justify-content-between">
    <div class="article-header__content">
      <span v-if="wordClassInfo.pronoun" v-lang:da class="article-header__element--light">{{
        wordClassInfo.pronoun
      }}</span>
      <h5
        v-lang:da
        class="article-header__word"
        :class="{ 'article-header__element': wordClassInfo.pronoun.length > 0 }"
      >
        {{ word.lemma }}
      </h5>
      <span
        v-if="word.wordClass"
        v-lang:da
        class="article-header__element article-header__element--light article-header__element--italic"
        v-html="wordClassInfo.wordClass"
      ></span>
      <span
        v-if="word.flexion"
        v-lang:da
        class="article-header__element article-header__element--light"
        v-html="'(' + word.flexion + ')'"
      ></span>
      <template v-if="word.alternative">
        <span class="article-header__element article-header__element--comment">
          {{ $t("article.polSchoolDada.alternativeDelim1") }}
        </span>
        <span class="article-header__word">{{ word.alternative }}</span>
        <span
          v-if="word.alternativeFlexion"
          v-lang:da
          class="article-header__element article-header__element--light"
          >({{ word.alternativeFlexion }})</span
        >
        <template v-if="word.alternative2">
          <span class="article-header__element article-header__element--comment ml-0">
            {{ $t("article.polSchoolDada.alternativeDelim2") }}
          </span>
          <span class="article-header__word">{{ word.alternative2 }}</span>
        </template>
      </template>
    </div>
  </div>
</template>
